import { toVarRef } from '@chakra-ui/theme-tools'
import { brand } from '@workday/canvas-tokens-web'

const baseStyle = {
  container: {},
  track: {
    _checked: {
      bg: toVarRef(brand.primary.base)
    },
    _disabled: {
      cursor: 'not-allowed'
    },
    _readOnly: {
      cursor: 'default'
    }
  },
  thumb: {}
}

export const Switch = {
  baseStyle,
  defaultProps: {
    size: 'lg'
  }
}
